/**
 * Helper services/functions for making api requests.
 */

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import toast from '@/services/toast';
//import JwtService from "@/common/jwt.service";
import {
  API_URL
} from "./config";

const ApiService = {
  init() {
    console.log('init')
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  // setHeader() {
  //     Vue.axios.defaults.headers.common[
  //         "Authorization"
  //     ] = `Token ${JwtService.getToken()}`;
  // },

  query(resource, params) {

    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource, params) {
    console.log(params);
    return Vue.axios.delete(`${resource}`, {
      data:
        params
    }).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  }
};

export default ApiService;

export const DownloadService = {
  /**
   * @param { collection_id or photo_ids, naming_structure, name, client_id }
   */
  zip(params) {
    toast.success('Processing download')
    params.download_mode = 'standard'
    if (params.watermark === true || params.imageCount > 30) {
      toast.success('Your images are being sent for proccessed. You will receive an email with a link to your file download')
      if (params.watermark === true) {
        params.download_mode = 'watermark'
      }else{
        params.download_mode = 'lambda_zip'
      }
    }
    console.log(params);
    axios({
      url: 'downloadzip',
      baseURL: '',
      method: 'post',
      data: params,
      responseType: 'blob',
    }).then((response) => {
      if (!response) return toast.error('There was an error with the download.')

      if (params.imageCount < 50 && params.watermark === false) {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = params.name + '_expd8_files.zip';
        if (contentDisposition) {

          // Sometimes comes through with or without speech marks.
          const fileNameMatchMarks = contentDisposition.match(/filename="(.+)"/);
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);

          if (fileNameMatchMarks) {
            if (fileNameMatchMarks.length === 2) {
              fileName = params.name + ' ' + fileNameMatchMarks[1];
            }
          }
          else if (fileNameMatch) {
            if (fileNameMatch.length === 2) {
              fileName = params.name + ' ' + fileNameMatch[1];
            }
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        toast.success('Download started.')
      }

    }).catch((err) => {
      toast.error('There was an error with the download.')
      console.log(err);
    });
    return;
  }
}

/**
 * Collection Services
 */
export const CollectionsService = {
  query(type, params) {
    return ApiService.query("collections" + (type === "feed" ? "/feed" : ""), {
      params: params
    });
  },
  get(id) {
    return ApiService.get("collections", id);
  },
  create(params) {
    return ApiService.post("collections", params);
  },
  update(id, params) {
    return ApiService.update("collections", id, params);
  },
  destroy(id) {
    return ApiService.delete(`collections/${id}`);
  }
}

/**
 * Expd8 client services
 */
export const ExpClientsService = {
  // Get a list of clients a user can access.
  getList(userId, params = {}) {
    return ApiService.query(`clients`, {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 25,
        search: params.search || ''
      }
    });
  },
  // Get client infomation.
  get(clientId) {
    return ApiService.get("clients", clientId);
  },
}
